import styled from 'styled-components';
import { IconPriceProps, PricesProps } from '..';

export const PricesContainer = styled.div<IconPriceProps>`
  position: relative;
  text-align: left;
  display: flex;
  flex-direction: column;
  min-height: ${({ visible }) => (visible ? '80px' : '60px')};

  & div:first-of-type p {
    font-size: 20px;
    font-weight: bold;
    color: ${({ theme }) => theme.Text.dark};
  }
`;

export const IconWrapper = styled.span<IconPriceProps>`
  height: 20px;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
`;

export const PriceStyled = styled.p<PricesProps>`
  text-align: left;
  font-size: 17px;
  font-weight: regular;
  font-family: Lato, sans-serif;
  color: ${({ theme }) => theme.Text.grey};
  margin-top: 2px;
  margin-bottom: 4px;
`;
